import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Button } from '@fpsm/cxy-components/Button';
import { Input } from '@fpsm/cxy-components/Input';
import { useFetcher } from '@remix-run/react';

import { type AuthResponse, getFieldErrorMessage } from '../../types';

import styles from './styles/ForgotPasswordForm.module.css';

export type ForgotPasswordFormProps = {
  repubPath: string;
};

export const ForgotPasswordForm = ({ repubPath }: ForgotPasswordFormProps) => {
  const fetcher = useFetcher<AuthResponse>();
  const [showErrorState, setShowErrorState] = useState(false);

  const { t } = useTranslation(['label']);

  const data = fetcher.data;
  const hasErrorMessage = data?.message && !data?.success;

  useEffect(() => {
    if (data?.fieldErrors || hasErrorMessage) {
      setShowErrorState(true);
    }
  }, [data?.fieldErrors, hasErrorMessage]);

  const onChange = () => {
    setShowErrorState(false);
  };

  return (
    <fetcher.Form
      action={`${repubPath}/plus/auth/forgot-password`}
      className={styles.forgotPasswordForm}
      data-testid="forgot-password-form"
      method="post"
    >
      <p className={styles.helperText}>{t('CX_AUTH_FORGOT_PASSWORD_INSTRUCTIONS')}</p>
      <Input
        errors={
          showErrorState ? ([getFieldErrorMessage(data?.fieldErrors?.email)].filter(Boolean) as string[]) : undefined
        }
        id="email"
        name="email"
        onChange={onChange}
        placeholder="Email"
        type="email"
      />
      {data?.message && (
        <p className={`${styles.responseMessage}${hasErrorMessage ? ` ${styles.errorMessage}` : ''}`}>{data.message}</p>
      )}

      <div className={styles.buttonSection}>
        <Button isLoading={fetcher.state !== 'idle'} size="large" type="submit" variant="secondary">
          {t('CX_AUTH_RESET_PASSWORD')}
        </Button>
      </div>
    </fetcher.Form>
  );
};
